module.exports = __webpack_public_path__ + "zvetseni-prsou_4_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_4_after.jpg
// module id = 1343
// module chunks = 0